<script>
  import HotelModulePage from "../../../../modules/Curatorial/Hotel/Page/HotelModulePage.svelte";

  const GOOGLE_SPREAD_ID = "1qYprnANhi5Lmr9ejz55Ae3D662yGOP66zwoTkMkhlok";
  const COMMON_CONFIG_SHEET_ID = "225415299";
</script>

<div class="tourPage_kv">
  <h3>
    <img
      src="/protected/img/curatorial/202008_twHotelStrategy/kv_title.svg"
      alt="" />
    <img
      class="kv_subtitle"
      src="/protected/img/curatorial/202008_twHotelStrategy/kv_subtitle.svg"
      alt="" />
  </h3>
</div>
<!-- <div class="discountIcon">
  <img
    src="/protected/img/curatorial/202008_twHotelStrategy/discount.svg"
    alt="" />
</div> -->

<HotelModulePage
  google_spread_id={GOOGLE_SPREAD_ID}
  common_config_sheet_id={COMMON_CONFIG_SHEET_ID} />
